import { render } from "./ViewerShare.vue?vue&type=template&id=59ffa4c8"
import script from "./ViewerShare.vue?vue&type=script&lang=js"
export * from "./ViewerShare.vue?vue&type=script&lang=js"

import "./ViewerShare.vue?vue&type=style&index=0&id=59ffa4c8&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__